import { ToastOptions } from "react-toastify";

export const isAdult = (birthDate: string) => {
  const today = new Date();
  const birth = new Date(birthDate);

  const age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  const dayDiff = today.getDate() - birth.getDate();

  if (
    age > 18 ||
    (age === 18 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)))
  ) {
    return true;
  }
  return false;
};

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const cpfMask = (value: string) => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
};

export const phoneMask = (value: string) => {
  return value
    .replace(/\D/g, "")
    .slice(0, 11)
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{4})(\d)/, "$1-$2")
    .replace(/(\d{4})-(\d)(\d{4})/, "$1$2-$3");
};

export const formatCurrencyToNumber = (value: string) => {
  return value.replace(/[R$\s.]/g, "").replace(",", ".");
};

export const currencyMask = (value: string): string => {
  // Remove all non-digit characters
  let numericValue = value.replace(/\D/g, "");

  // Convert to number and divide by 100 to handle decimal places
  const numeric = numericValue === "" ? 0 : Number(numericValue) / 100;

  // Format as currency
  return numeric.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  });
};

export const formatCurrency = (value?: number) => {
  if (value === undefined || value === null) return "";
  try {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    }).format(value);
  } catch {
    return `R$ ${value.toFixed(2)}`;
  }
};

export const toastOptions: ToastOptions = {
  position: "top-right",
  autoClose: 9000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
